export enum ControlItem {
  HealthCheck = 'Health Check',
  ServiceLogs = 'Service Logs',
  BotLogs = 'Bot Logs',
  Queues = 'Queues',
  ErrorLogs = 'Error Logs',
  CreateUser = 'Create User',
  EditUser = 'Edit User',
  ManagePassword = 'Manage Password',
  RemoveUser = 'Remove User',
  PanicSell = 'Panic Sell',
  CreateBot = 'Create Bot',
  EditBot = 'Edit Bot',
  BotStates = 'Bot States',
  RemoveBot = 'Remove Bot',
  AddBalance = 'Add Balance',
  MoveBalance = 'Move Balance',
  RemoveBalance = 'Remove Balance',
  CbrtRange = 'Cbrt Range',
  CreateSubscription = 'Create Subscription',
  EditSubscription = 'Edit Subscription',
  RemoveSubscription = 'Remove Subscription',
  SubscriptionStates = 'Subscription States',
}

export type BotState = {
  userId: string;
  botId: string;
  baseAsset: string;
  quoteAsset: string;
  isActive: boolean;
  latestOrder: string;
  nextWakeUp: null;
  isDisabled?: boolean;
};

export type SubscriptionState = {
  subscriptionId: number;
  userId: string;
  clusterId: string;
  botId: string;
  baseAsset: string;
  quoteAsset: string;
  isActive: boolean;
  isAutomatedOrder: boolean;
  isNotificationEnabled: boolean;
  isDisabled?: boolean;
};
